import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Fetch } from '../utils/Utils.js';
import SuccessMessage from '../shared/SuccessMessage.js';
import ErrorMessage from '../shared/ErrorMessage.js';
import { plansOfType } from '../shared/lots/planTypes.js';

const WeightProtocolSettings = () => {
  const { t } = useTranslation();
  const [protocols,          setProtocols]          = useState([]);
  const [settings,           setSettings]           = useState(null);
  const [selectedProtocolId, setSelectedProtocolId] = useState('');
  const [success,            setSuccess]            = useState('');
  const [error,              setError]              = useState('');

  useEffect(() => {
    Fetch('/api/data/lots.plans', 'GET', null,
      (data) => setProtocols(plansOfType(data, 'weight')), () => {}
    );
    Fetch('/api/data/account.settings', 'GET', null,
      (data) => {
        if (data?.[0]) {
          setSettings(data[0]);
          setSelectedProtocolId(data[0].default_weight_protocol_id || '');
        }
      }, () => {}
    );
  }, []);

  const handleChange = (e) => {
    const id = e.target.value;
    setSuccess(''); setError('');
    const body = { default_weight_protocol_id: id };
    const method = settings?._id ? 'PATCH' : 'POST';
    if (settings?._id) body._id = settings._id;
    Fetch('/api/data/account.settings', method, JSON.stringify(body),
      () => { setSelectedProtocolId(id); setSuccess(t('settings_saved')); },
      () => setError(t('settings_save_error'))
    );
  };

  return (
    <div className="DataCollectionAdd">
      <h3>{t('default_weight_protocol_settings')}</h3>
      <p className="settings-hint">{t('default_weight_protocol_hint')}</p>
      <select value={selectedProtocolId} onChange={handleChange}>
        <option value="">— {t('none')} —</option>
        {protocols.map(p => (
          <option key={p._id} value={p._id}>{p.name}</option>
        ))}
      </select>
      <SuccessMessage message={success} />
      <ErrorMessage message={error} />
    </div>
  );
};

export default WeightProtocolSettings;
